import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Divider } from "@mui/material";

import { CountryDetailContext } from "contexts/CountryDetailContext";

import { BreadcrumbLayout } from "layouts/BreadcrumbLayout";
import { CustomTabs } from "components/Shared/CustomTabs";
import { CustomTabPanel } from "components/Shared/CustomTabPanel";
import { RowsSkeleton } from "components/Shared/Skeleton/RowsSkeleton";
import { CountryBasicDetail } from "./countryComponents/CountryBasicDetail";
import { ToggleCountryStatus } from "./countryComponents/ToggleCountryStatus";
import { CountryAdministrativeRegionsTab } from "./countryComponents/CountryAdministrativeRegionsTab";

import { useGetCountryDetailQuery } from "store/services/countryApi";

import { useAppMeta } from "hooks";

export const CountryDetailScreen = () => {
  const { id } = useParams();

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "regions";

  const breadcrumbs = [
    { title: "Countries", path: "/app/crm/country/list" },
    { title: "Country Detail" },
  ];

  const countyDetailTabs = [
    { label: "Administrative Regions", value: "regions" },
  ];

  // RTK Query
  const {
    data: countryDetail,
    isLoading,
    isFetching,
    error,
  } = useGetCountryDetailQuery(id);

  const loadingCountry = isLoading || isFetching;

  useAppMeta("Country Detail");

  return (
    <CountryDetailContext.Provider value={{ countryDetail, loadingCountry }}>
      <BreadcrumbLayout
        {...{ breadcrumbs, isBusy: loadingCountry }}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error {...{ error }} />

        <BreadcrumbLayout.Paper>
          <CountryBasicDetail />

          <Divider />

          <CustomTabs tabs={countyDetailTabs} activeTab={activeTab} />

          {!loadingCountry ? (
            <>
              <CustomTabPanel activeTab={activeTab} value="regions">
                <CountryAdministrativeRegionsTab />
              </CustomTabPanel>
            </>
          ) : (
            <RowsSkeleton />
          )}
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </CountryDetailContext.Provider>
  );
};

const PageActions = () => {
  return (
    <>
      <ToggleCountryStatus />
    </>
  );
};
